import React from 'react';
import {Rgb} from '../../models/product';
import './index.scss';
import Check from '../../assets/icons/check.svg';
import WhiteCheck from '../../assets/icons/check_white.svg';

const backgroundColor = (rgb: Rgb) => `rgb(${[rgb.red, rgb.green, rgb.blue]})`;
const checkedImage = (rgb: Rgb) =>
  rgb.red > 128 || rgb.green > 128 || rgb.blue > 128 ? Check : WhiteCheck;

type ProductColorCheckboxProps = {
  rgb: Rgb;
  trimRgb: Rgb | null;
  colorName: string;
  selected: boolean;
  toggleSelected: () => void;
};

function Trim(props: {rgb: Rgb}) {
  const {rgb} = props;
  const styles = {
    backgroundColor: backgroundColor(rgb)
  };
  return <div className="productColorCheckbox-trim" style={styles} />;
}

const ProductColorCheckbox: React.FC<ProductColorCheckboxProps> = (
  props: ProductColorCheckboxProps
) => {
  const {rgb, trimRgb, colorName, selected, toggleSelected} = props;
  const styles = {
    backgroundColor: backgroundColor(rgb)
  };

  return (
    <button
      className={`productColorCheckbox${selected ? ' selected' : ''}`}
      type="button"
      style={styles}
      aria-label={colorName}
      onClick={toggleSelected}>
      {trimRgb && <Trim rgb={trimRgb} />}
      {selected && (
        <img className="selectedImg" src={checkedImage(rgb)} alt="selected" />
      )}
    </button>
  );
};

export default ProductColorCheckbox;
